import { makeStyles, mergeClasses, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme/M365PulseTheme.types";
import { useSmallScreen } from "Shared/Hooks";

const useLoginPageStyles = makeStyles({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100vw",
        backgroundColor: themeTokens.colorNeutralBackground2,
        position: "fixed",
        top: 0,
        left: 0
    },
    login: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    loginLarge: {
        ...shorthands.padding(themeTokens.spacingVerticalXL, themeTokens.spacingHorizontalXXL),
        borderRadius: themeTokens.borderRadiusMedium
    },
    pulseLogo: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: themeTokens.spacingVerticalXXL,
        marginTop: themeTokens.spacingVerticalL
    },
    pulseText: {
        paddingLeft: themeTokens.spacingHorizontalM,
        fontSize: "20px",
        color: themeTokens.colorNeutralForeground3
    },
    signInText: {
        display: "flex",
        justifyContent: "center",
        marginBottom: themeTokens.spacingVerticalL,
        fontSize: "14px"
    },
    primaryLoginButton: {
        width: "300px",
        marginBottom: themeTokens.spacingVerticalM,
        height: "35px"
    },
    secondaryLoginButton: {
        backgroundColor: themeTokens.colorNeutralBackground1,
        ...shorthands.borderWidth(themeTokens.strokeWidthThicker)
    },
    signInButtons: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: themeTokens.spacingVerticalXL
    },
    error: {
        color: themeTokens.colorPaletteRedForeground1,
        width: "300px",
        textAlign: "center"
    }
});

export const useStyles = () => {
    const isSmallScreen = useSmallScreen();

    const styles = useLoginPageStyles();
    styles.login = isSmallScreen ? styles.login : mergeClasses(styles.login, styles.loginLarge);
    styles.secondaryLoginButton = mergeClasses(styles.primaryLoginButton, styles.secondaryLoginButton);

    return styles;
};
